<div class="link-modal">
  <div class="modal-head">
    <div class="title-block">
      <h2>Share Timesheet Approval Link</h2>
      <p class="sub">Send each approver their personal link to review and approve.</p>
    </div>
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="approver-list" *ngIf="timesheetApprovalLinks?.length">
      <div class="approver-row" *ngFor="let timesheetApprovalLink of timesheetApprovalLinks; let i = index">
        <div class="user-row">
          <div class="avatar">
            <img *ngIf="timesheetApprovalLink.approver_pic"
                 [src]="dataSharedService.getImage(timesheetApprovalLink.approver_pic)"
                 [alt]="timesheetApprovalLink.approver" />
            <span *ngIf="!timesheetApprovalLink.approver_pic">
              {{ authService.getInitials(timesheetApprovalLink.approver) }}
            </span>
          </div>
          <div class="meta">
            <div class="name">{{ timesheetApprovalLink.approver }}</div>
            <div class="muted">Approver</div>
          </div>
        </div>
        <div class="link-input-wrap">
          <input type="text" class="input-form"
                 [value]="timesheetApprovalLink.approver_link" readonly />
          <button type="button" class="btn btn-primary copy-btn"
                  (click)="copyLink(timesheetApprovalLink.approver_link)">
            <i class="bi bi-clipboard"></i>
            <span>Copy</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
